<template>
    <div class="excavate-relevance">
        <div class="excavate-tip"><span></span> 关联分析又称关联挖掘，就是在交易数据、关系数据或其他信息载体中，查找存在于项目集合或对象集合之间的频繁模式、关联、相关性或因果结构。或者说，关联分析是发现数据库中不同项之间的联系。</div>
        <div class="excavate-table">
            <el-table
                :data='relevanceList'
                :header-cell-style="{background:'#a7754f',color:'#fff'}"
                size='mini'
                border
                default-expand-all>
                <el-table-column
                    width="170px"
                    label="名称"
                    prop="name"
                >
                </el-table-column>
                <el-table-column
                    prop="explain"
                    label="解释">
                </el-table-column>
                <el-table-column
                    width="240px"
                    prop="formula"
                    label="公式">
                </el-table-column>
            </el-table>
        </div>
        <analysisOption @option_click='option_click'> </analysisOption>
        <div class="flex-end">
            <el-button  type="primary" size="small" @click='relevance_click'>关联分析</el-button>
        </div>
        
    </div>
</template>

<script>
import analysisOption from "./comps/analysis_option.vue"
import excavateData from './comps/excavateData.js'
export default {
    components: {
        analysisOption,
    },
    data () {
        return {
            // 和组件内部的值保持统一
            beforeRadio:'clinicalFeature',
            beforeValue:'临床表现',
            afterRadio:'clinicalFeature',
            afterValue:'临床表现',
            radioOption:excavateData.radioOption,
            relevanceList:excavateData.relevanceList
        }
    },
    methods: {
        // 获取选择后的值
        option_click(params){
            if(params.type=='before'){
                this.beforeRadio = params.val;
                this.beforeValue=params.valName
            }else if(params.type=='after'){
                this.afterRadio = params.val;
                this.afterValue=params.valName
            }
        },
        // 关联分析
        relevance_click(){
            // let optionLable=[this.beforeRadio,this.afterRadio]
            let optionLable ='';
            if(this.beforeRadio==this.afterRadio){
                optionLable=this.beforeRadio
            }else{
                optionLable=`${this.beforeRadio},${this.afterRadio}`
            }
            this.$router.push({
                path:'detailsRelevance',
                query:{
                    optionLable,
                    beforeValue:this.beforeValue,
                    afterValue:this.afterValue,
                }
            }) 
        },
    }
}
</script>

<style>

</style>